// import { BlobServiceClient } from '@azure/storage-blob';

const storageAccountName = process.env.REACT_APP_AZURE_STORAGE_ACCOUNT;
const containerName = process.env.REACT_APP_AZURE_CONTAINER_NAME;
const sasToken = process.env.REACT_APP_AZURE_SAS_TOKEN;


const uploadImageToBlob = async (file) => {
  const fixedFileName = "sponsor.jpg"; 
  const blobUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${fixedFileName}?${sasToken}`;

  const response = await fetch(blobUrl, {
    method: "PUT",
    headers: {
      "x-ms-blob-type": "BlockBlob",
      "Content-Type": file.type,
    },
    body: file,
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Upload failed: ${response.status} ${response.statusText}\n${errorText}`);
  }

 
  return blobUrl.split('?')[0];
};


export default uploadImageToBlob;
